import "bootstrap/dist/css/bootstrap.min.css";
import BarGraph from "components/graphs/BarGraph";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";

const SBASServiceAvailabilityCard = ({ innerRef, data }) => {
  const renderServiceAvailabilityPlots = (operation, satellitePrn) => (
    <React.Fragment key={operation.name}>
      <p className="text-justify">
        {operation.name} service availability plots with SBAS GEO {satellitePrn}{" "}
        (ICAO thresholds: {operation.plots[0].thresholdValues[0]} m for
        horizontal and {operation.plots[1].thresholdValues[0]} m for vertical)
      </p>
      <Row>
        {operation.plots.map((plot, index) => (
          <Col key={index} sm={{ span: 12 }} xxl={{ span: 5, offset: 1 }}>
            <BarGraph width={400} height={200} dataset={plot} />
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );

  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Availability
      </Card.Title>
      <Card.Body>
        {data.satellites.map((satellite, index) => (
          <React.Fragment key={index}>
            {satellite.operations.map((operation, index) => (
              <React.Fragment key={index}>
                {operation.plots.length === 1 ? (
                  <React.Fragment key={index}>
                    <p className="text-justify">
                      {operation.name} service availability plots with SBAS GEO{" "}
                      {satellite.prn} (ICAO threshold:{" "}
                      {operation.plots[0].thresholdValues[0]}%)
                    </p>
                    <Row>
                      {operation.plots.map((plot, index) => (
                        <Col key={index} xxl={{ span: 11, offset: 1 }}>
                          <BarGraph width={400} height={400} dataset={plot} />
                        </Col>
                      ))}
                    </Row>
                  </React.Fragment>
                ) : (
                  renderServiceAvailabilityPlots(operation, satellite.prn)
                )}
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <SBASServiceAvailabilityCard innerRef={ref} {...props} />
  ))
);
